import React, { useContext, useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { getAllRegion } from '../../redux/slices/regionSlice'
import { useDispatch, useSelector } from 'react-redux'
import { getCityByRegion } from '../../redux/slices/citySlice'
import { DateRange } from 'react-date-range'
import TotalRevenue from '../../assets/img/svg/total-revenue.svg'
// import Refunds from '../../assets/img/svg/refunds.svg'
import Properties from '../../assets/img/svg/properties.svg'
import NewClient from '../../assets/img/svg/people.svg'
import TableView from '../../component/common/tableView'
import { itemRender } from '../../helper/paginationfunction'
import { Button } from 'reactstrap'
import { convertTimestampToDate, formatAmount, getDayStartAndEndTimestamps, getTimeStamp, getUserRole, hasAccess } from '../../helper/function'
import {
  getRegionBestCleaners,
  getRegionBestClient,
  getRegionBestPropertyReport,
  getRegionMatrixReport,
  getRegionWiseCleaners,
  getRegionWiseClients,
  getRegionWiseProperty
} from '../../redux/slices/reportSlice'
import { SpinnerContext } from '../../context/spinnerContext'
import RatingDisplay from '../../component/rating'

const Region = () => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allRegion } = useSelector(({ region }) => region)
  const { allCityByRegion } = useSelector(({ city }) => city)
  const [selectedRegion, setSelectedRegion] = useState(allRegion[0]?.region_id)
  const [selectedCity, setSelectedCity] = useState('')
  const [pagesize, setPagesize] = useState(10)
  const [page, setPage] = useState(1)
  const [cleanersPage, setCleanersPage] = useState(1)
  const [cleanersPageSize, setCleanersPageSize] = useState(10)
  const [propertiesPage, setPropertiesPage] = useState(1)
  const [propertiesPageSize, setPropertiesPageSize] = useState(10)

  const resetPagination = () => {
    setPage(1)
    setPagesize(10)
    setCleanersPage(1)
    setCleanersPageSize(10)
    setPropertiesPage(1)
    setPropertiesPageSize(10)
  }

  const {
    allRegionBestProperty,
    allRegionBestCleaners,
    allRegionBestClient,
    allRegionCleaners,
    allRegionClient,
    allRegionProperty,
    reportRegionMatrix
  } = useSelector((state) => state.report)

  useEffect(() => {
    if (allRegion && allRegion.length > 0) {
      setSelectedRegion(null) // Set the default region ID after regions are loaded
    }
  }, [allRegion])

  const handlePagination = async (page, pageSize) => {
    setPage(page)
    setPagesize(pageSize)
  }

  const [showDatePicker, setShowDatePicker] = useState(false)
  const [timeline, setTimeline] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ])
  const [range, setRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ])

  // Utility Functions
  const clearSelection = () => {
    setRange([{ startDate: null, endDate: null, key: 'selection' }])
    setTimeline([{ startDate: new Date(), endDate: new Date(), key: 'selection' }])
    setSelectedRegion(allRegion[0]?.region_id)
    setSelectedCity('')
    setShowDatePicker(false)
    resetPagination()
  }

  const toggleDatePicker = () => {
    setShowDatePicker((prev) => !prev)
  }

  const handleSelect = (ranges) => {
    setRange([ranges?.selection])
    setTimeline([ranges?.selection])
    setShowDatePicker(false) // Close picker after selection (optional)
    resetPagination()
  }

  useEffect(() => {
    dispatch(getAllRegion())
      .then(() => {})
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (selectedRegion) {
      dispatch(getCityByRegion(selectedRegion))
    }
  }, [selectedRegion])
  const isValidDate = (date) => date && !isNaN(date)

  useEffect(() => {
    const fetchPropertyReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)
      changeLoader(true)

      const propertyPayload = {
        region_id: selectedRegion,
        city_id: selectedCity,
        page: propertiesPage,
        limit: propertiesPageSize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        await dispatch(getRegionBestPropertyReport(propertyPayload))
      } catch (error) {
        console.error('Error fetching property report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchPropertyReport()
  }, [range, selectedRegion, selectedCity, propertiesPage, propertiesPageSize])

  useEffect(() => {
    const fetchCleanerReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)
      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      changeLoader(true)

      const cleanerPayload = {
        region_id: selectedRegion,
        city_id: selectedCity,
        page: cleanersPage,
        limit: cleanersPageSize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        await dispatch(getRegionBestCleaners(cleanerPayload))
      } catch (error) {
        console.error('Error fetching cleaner report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchCleanerReport()
  }, [range, selectedRegion, selectedCity, cleanersPage, cleanersPageSize])

  useEffect(() => {
    const fetchClientReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      changeLoader(true)

      const clientPayload = {
        region_id: selectedRegion,
        city_id: selectedCity,
        page: page,
        limit: pagesize,
        ...(isValidDate(start_date) && isValidDate(end_date) && { from_date: start_date, to_date: endOfDayTimestamp })
      }

      try {
        await dispatch(getRegionBestClient(clientPayload))
      } catch (error) {
        console.error('Error fetching client report:', error)
      } finally {
        changeLoader(false)
      }
    }

    fetchClientReport()
  }, [range, selectedRegion, selectedCity, page, pagesize])

  useEffect(() => {
    const fetchRegionMatrixReport = async () => {
      const start_date = getTimeStamp(range[0]?.startDate)
      const end_date = getTimeStamp(range[0]?.endDate)

      const { endOfDayTimestamp } = getDayStartAndEndTimestamps(end_date)

      try {
        const payload = {
          region_id: selectedRegion,
          city_id: selectedCity,
          ...(isValidDate(start_date) && isValidDate(end_date) ? { from_date: start_date, to_date: endOfDayTimestamp } : {})
        }

        await Promise.all([
          dispatch(getRegionWiseCleaners(payload)),
          dispatch(getRegionWiseClients(payload)),
          dispatch(getRegionWiseProperty(payload)),
          dispatch(getRegionMatrixReport(payload))
        ])
        changeLoader(false)
      } catch (error) {
        console.error('Error fetching reports:', error)
        changeLoader(false)
      }
    }

    fetchRegionMatrixReport()
  }, [range, selectedRegion, selectedCity])

  const handleSelectRegion = (region_id) => {
    setSelectedRegion(region_id)
    resetPagination()
    setSelectedCity('')
  }
  const handleSelectCity = (cityId) => {
    setSelectedCity(cityId)
    resetPagination()
  }

  const handleCleanersPagination = (page, pageSize) => {
    setCleanersPage(page)
    setCleanersPageSize(pageSize)
  }

  const handlePropertiesPagination = (page, pageSize) => {
    setPropertiesPage(page)
    setPropertiesPageSize(pageSize)
  }

  const bestClientsColumns = [
    {
      title: 'Best Clients',
      dataIndex: 'clientName',
      key: 'clientName'
    },
    hasAccess('revenueView', getUserRole()) && {
      title: 'Revenue',
      dataIndex: 'revenue',
      key: 'revenue',
      render: (revenue) => <span>{revenue ? formatAmount(revenue) : 0}</span>
    },
    {
      title: 'Property',
      dataIndex: 'totalProperties',
      key: 'totalProperties',
      render: (property) => (
        <span>
          {property} <span style={{ color: 'gold' }}></span>
        </span>
      )
    },
    {
      title: 'Jobs',
      dataIndex: 'jobs',
      key: 'jobs'
    }
  ].filter(Boolean)

  const cleanerColumns = [
    {
      title: 'Best Cleaner',
      dataIndex: 'cleanersName',
      key: 'cleanersName'
    },
    {
      title: 'Jobs',
      dataIndex: 'jobs',
      key: 'jobs'
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
      key: 'rating',
      render: (rating) => <RatingDisplay selectedValue={rating} />
      // render: (rating) => <Rate disabled defaultValue={rating} />
    }
  ]

  const propertyColumns = [
    {
      title: 'Best Properties',
      dataIndex: 'propertyName',
      key: 'propertyName'
    },
    {
      title: 'Clients',
      dataIndex: 'clientName',
      key: 'clientName'
    },
    {
      title: 'Jobs',
      dataIndex: 'jobs',
      key: 'jobs'
    },
    hasAccess('revenueView', getUserRole()) && {
      title: 'Revenue',
      dataIndex: 'totalrevenue',
      key: 'totalrevenue',
      render: (revenue) => <span>{revenue ? formatAmount(revenue) : 0}</span>
    },
    // {
    //   title: 'Profit %',
    //   dataIndex: 'profit',
    //   key: 'profit'
    // },
    {
      title: 'Active Since',
      dataIndex: 'activeSince',
      render: (text) => <p>{convertTimestampToDate(text)}</p>
    }
  ].filter(Boolean)

  return (
    <div>
      <div className="deshboard_topbar">
        <div className="schedule_sec dropdown_with_btn">
          <div className="regions_sec">
            <Dropdown>
              <Dropdown.Toggle className="dropdown_opction_one" id="dropdown-basic">
                {selectedRegion ? allRegion?.find((region) => region.region_id === selectedRegion)?.region : 'Regions'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleSelectRegion(null)}>All Regions</Dropdown.Item>
                {allRegion?.map((region) => (
                  <Dropdown.Item key={region.region_id} onClick={() => handleSelectRegion(region.region_id)}>
                    {region.region}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="regions_sec">
            <Dropdown>
              <Dropdown.Toggle className="dropdown_opction_one" id="dropdown-basic">
                {selectedCity ? allCityByRegion?.find((prop) => prop.city_id === selectedCity).city : 'City'}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleSelectCity(null)}>All City</Dropdown.Item>
                {allCityByRegion?.map((city) => (
                  <Dropdown.Item key={city.city_id} className="dropdown_opction" onClick={() => handleSelectCity(city.city_id)}>
                    {city.city}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="regions_sec">
            {/* Date Range Dropdown */}
            <Dropdown show={showDatePicker} onToggle={() => toggleDatePicker()}>
              <Dropdown.Toggle className="dropdown_opction_one" id="date-range-dropdown">
                Date Range
              </Dropdown.Toggle>

              <Dropdown.Menu className="date_picker_dropdown">
                {showDatePicker && (
                  <div className="date_picker_box_filter_div">
                    <DateRange
                      editableDateInputs
                      onChange={handleSelect}
                      moveRangeOnFirstSelection={false}
                      showSelectionPreview={true}
                      ranges={timeline}
                      className="date_range_selector"
                      direction="vertical"
                    />
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="regions_sec">
            <Button className="btn btn-primary btn-small circle_btn" onClick={() => clearSelection()}>
              Clear Selection
            </Button>
          </div>
        </div>
      </div>
      <div className="row mb-4 row_gap_div">
        {/* <!-- Clients Card --> */}
        <div className={`col-md-6 col-lg-6 ${hasAccess('revenueView', getUserRole()) ? 'col-xl-3' : ' col-xl-4'}`}>
          <div className="table-card-div">
            <div className="report-card-header">
              <div className="deshboard_topbar_imgsec">
                <img className="cleaning_tool_img" src={NewClient} alt="cleaning_tool" />
              </div>
              <span className="ms-1">Clients</span>
            </div>
            <div className="report-card-body">
              <div className="report-data-row">
                <span>Total</span>
                <span>{allRegionClient?.totalClients ? allRegionClient?.totalClients : 0} </span>
              </div>
              <div className="report-data-row">
                <span>New</span>
                <span>{allRegionClient?.newClients ? allRegionClient?.newClients : 0}</span>
              </div>
              <div className="report-data-row">
                <span>Inactive</span>
                <span>{allRegionClient?.totalInActiveClients ? allRegionClient?.totalInActiveClients : 0}</span>
              </div>
              <div className="report-data-row">
                <span>Growth</span>
                <span>0%</span>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Properties Card --> */}
        <div className={`col-md-6 col-lg-6 ${hasAccess('revenueView', getUserRole()) ? 'col-xl-3' : ' col-xl-4'}`}>
          <div className="table-card-div">
            <div className="report-card-header">
              <div className="deshboard_topbar_imgsec">
                <img className="cleaning_tool_img" src={Properties} alt="cleaning_tool" />
              </div>
              <span className="ms-1">Properties</span>
            </div>
            <div className="report-card-body">
              <div className="report-data-row">
                <span>Total</span>
                <span>{allRegionProperty?.totalProperties ? allRegionProperty?.totalProperties : 0} </span>
              </div>
              <div className="report-data-row">
                <span>New</span>
                <span>{allRegionProperty?.newProperties ? allRegionProperty?.newProperties : 0} </span>
              </div>
              <div className="report-data-row">
                <span>Inactive</span>
                <span>{allRegionProperty?.totalInActiveProperties ? allRegionProperty?.totalInActiveProperties : 0}</span>
              </div>
              <div className="report-data-row">
                <span>Growth</span>
                <span>0%</span>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Cleaners Card --> */}
        <div className={`col-md-6 col-lg-6 ${hasAccess('revenueView', getUserRole()) ? 'col-xl-3' : ' col-xl-4'}`}>
          <div className="table-card-div">
            <div className="report-card-header">
              <div className="deshboard_topbar_imgsec">
                <img className="cleaning_tool_img" src={NewClient} alt="cleaning_tool" />
              </div>
              <span className="ms-1">Cleaners</span>
            </div>
            <div className="report-card-body">
              <div className="report-data-row">
                <span>Total</span>
                <span>{allRegionCleaners?.totalCleaners ? allRegionCleaners?.totalCleaners : 0} </span>
              </div>
              <div className="report-data-row">
                <span>New</span>
                <span>{allRegionCleaners?.newCleaners ? allRegionCleaners?.newCleaners : 0}</span>
              </div>
              <div className="report-data-row">
                <span>Inactive</span>
                <span>{allRegionCleaners?.totalInActiveCleaners ? allRegionCleaners?.totalInActiveCleaners : 0}</span>
              </div>
              <div className="report-data-row">
                <span>Growth</span>
                <span>0%</span>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Finance Card --> */}
        {hasAccess('revenueView', getUserRole()) && (
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="table-card-div">
              <div className="report-card-header">
                <div className="deshboard_topbar_imgsec">
                  <img className="cleaning_tool_img" src={TotalRevenue} alt="cleaning_tool" />
                </div>
                <span className="ms-1">Finance</span>
              </div>
              <div className="report-card-body">
                <div className="report-data-row">
                  <span>Revenue</span>
                  <span>{reportRegionMatrix?.revenue ? formatAmount(reportRegionMatrix?.revenue) : 0}</span>
                </div>
                <div className="report-data-row">
                  <span>Refunds</span>
                  <span>{reportRegionMatrix?.refund ? formatAmount(reportRegionMatrix?.refund) : 0}</span>
                </div>
                <div className="report-data-row">
                  <span>Payouts</span>
                  <span>{reportRegionMatrix?.payouts ? formatAmount(reportRegionMatrix?.payouts) : 0}</span>
                </div>
                <div className="report-data-row">
                  <span>Gross Income</span>
                  <span>{reportRegionMatrix?.grossIncome ? formatAmount(reportRegionMatrix?.grossIncome) : 0}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row mb-4 row_gap_div">
        <div className="col-md-6 col-lg-6 col-xl-6">
          <div className="table-card-div">
            <div className="report-card-header">
              <div className="deshboard_topbar_imgsec">
                <img className="cleaning_tool_img" src={TotalRevenue} alt="cleaning_tool" />
              </div>
              <span className="ms-1">Jobs</span>
            </div>
            <div className="report-card-body">
              <div className="report-data-row">
                <span>Total</span>
                <span>{reportRegionMatrix?.totalJobs ? `${reportRegionMatrix?.totalJobs}` : 0}</span>
              </div>
              <div className="report-data-row">
                <span>Deep Cleaning</span>
                <span>{reportRegionMatrix?.deepCleanings}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-6 col-xl-6">
          <div className="table-card-div h-100 d-flex align-items-center justify-content-center">
            <div className="customer_retention_cls">
              <h4 className="mb-0">Costume Retention 0%</h4>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-4 row_gap_div">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
          <div className="table-card-div h-100">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={bestClientsColumns}
                    scroll={allRegionBestClient?.report?.length > 0 ? { x: true } : false}
                    dataSource={allRegionBestClient?.report || []}
                    paginationConfig={{
                      total: allRegionBestClient?.totalRecords,
                      defaultPageSize: allRegionBestClient?.limit || 10,
                      defaultCurrent: allRegionBestClient?.currentpage || 1,
                      current: page,
                      pageSize: pagesize,
                      showSizeChanger: true,
                      pageSizeOptions: [10, 25, 50, 100],
                      onChange: (page, pageSize) => handlePagination(page, pageSize),
                      itemRender: itemRender
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={cleanerColumns}
                    scroll={allRegionBestCleaners?.report?.length > 0 ? { x: true } : false}
                    dataSource={allRegionBestCleaners?.report || []}
                    paginationConfig={{
                      total: allRegionBestCleaners?.totalRecords,
                      current: cleanersPage,
                      pageSize: cleanersPageSize,
                      showSizeChanger: true,
                      pageSizeOptions: [10, 25, 50, 100],
                      onChange: handleCleanersPagination,
                      itemRender: itemRender
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-card-div">
            <div className="card-table">
              <div className="card-body purchase">
                <div className="table-responsive table-hover">
                  <TableView
                    columns={propertyColumns}
                    scroll={allRegionBestProperty?.report?.length > 0 ? { x: true } : false}
                    dataSource={allRegionBestProperty?.report || []}
                    paginationConfig={{
                      total: allRegionBestProperty?.totalRecords,
                      current: propertiesPage,
                      pageSize: propertiesPageSize,
                      showSizeChanger: true,
                      pageSizeOptions: [10, 25, 50, 100],
                      onChange: handlePropertiesPagination,
                      itemRender: itemRender
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Region
